<ng-container *ngIf="(columns$ | async) as columns">
  <prlw-table-manage-overlay-ui
    [columns]="columns"
    (toggleColumnVisible)="toggleColumnVisible($event)"
    (closeOverlay)="close()"
  ></prlw-table-manage-overlay-ui>
</ng-container>
